import React from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import '../styles/layouts/_mainLayout.scss';

function MainLayout({ children, customHeader, customFooter }) {
  const HeaderComponent = customHeader || Header;
  const FooterComponent = customFooter || Footer;

  return (
    <div className="main-layout">
      <HeaderComponent />
      <main className="main-content">
        {children}
      </main>
      <FooterComponent />
    </div>
  );
}

export default MainLayout;
